import { GetCalendarEventsQuery } from '@/api';

export const EVENT_TYPES = ['popup', 'delivery', 'cafe', 'catering'] as const;

export type EventType = (typeof EVENT_TYPES)[number];

export enum CalendarEventStatus {
  COMPLETED = 'completed',
  SCHEDULED = 'scheduled',
  NOT_READY = 'not_ready',
  READY = 'ready',
}

export type EventVariant = 'filled' | 'outline' | 'transparent';

export type EventInfo = {
  id: string;
  accountName: string;
  status: CalendarEventStatus;
  startTime: string;
};

export type EventTypeState = {
  statusGrade: EventStatusGrade;
  count: number;
  variant: EventVariant;
  bg: string;
  color: string;
  icon: boolean;
  events: EventInfo[];
};

export type EventsState = {
  cafe: EventTypeState;
  popup: EventTypeState;
  delivery: EventTypeState;
  catering: EventTypeState;
};

export type EventStatusSettings = {
  statusGrade: EventStatusGrade;
  variant: EventVariant;
  icon: boolean;
};

export type EventStatusGrade = 0 | 1 | 2 | 3 | 4 | 5;

export type EventsByDay = Map<string, EventsState>;

// Extract the event nodes array type from GetCalendarEvents query
type CalendarEventNodesArray = NonNullable<
  NonNullable<GetCalendarEventsQuery['searchEventVendors']>['eventVendors']
>['nodes'];

// Extract individual calendar event node type
export type CalendarEventNode = NonNullable<CalendarEventNodesArray>[number];

export type CalendarEvent = NonNullable<CalendarEventNode>;

export type CalendarCateringEvent = Extract<CalendarEvent, { __typename: 'CateringEventVendor' }>;

export type CalendarPopupEvent = Extract<CalendarEvent, { __typename: 'PopupEventVendor' }>;

export type CalendarCafeEvent = CalendarPopupEvent;

export type CalendarDeliveryEvent = Extract<CalendarEvent, { __typename: 'SelectEventVendor' }>;

// Extract vendor types from each event type
export type PopupEventVendor = NonNullable<CalendarPopupEvent['popupEvent']>;
export type CafeEventVendor = PopupEventVendor;
export type DeliveryEventVendor = NonNullable<CalendarDeliveryEvent['selectEvent']>;
export type CateringEventVendor = NonNullable<CalendarCateringEvent['event']>;

// Union type for all vendor types
export type CalendarEventVendor =
  | PopupEventVendor
  | CafeEventVendor
  | DeliveryEventVendor
  | CateringEventVendor;

export type TEventDetails =
  | CalendarPopupEvent['popupEvent']
  | CalendarDeliveryEvent['selectEvent']
  | CalendarCateringEvent['event'];

export type TCalendarEvent =
  | CalendarPopupEvent
  | CalendarCafeEvent
  | CalendarDeliveryEvent
  | CalendarCateringEvent;

export type EventTypeFilter = {
  label: string;
  value: boolean;
};

export enum CalendarEventDetailsUrl {
  POPUP_UPCOMING = '/calendar/popup_upcoming/',
  POPUP_COMPLETED = '/calendar/popup_completed/',
  CAFE_UPCOMING = '/calendar/popup_upcoming/',
  CAFE_COMPLETED = '/calendar/popup_completed/',
  DELIVERY_UPCOMING = '/calendar/delivery_upcoming/',
  DELIVERY_COMPLETED = '/calendar/delivery_completed/',
  CATERING_UPCOMING = '/calendar/catering_upcoming/',
  CATERING_COMPLETED = '/calendar/catering_completed/',
}
